import axios from 'axios';
import { Dispatch } from 'redux';
import {
  NpcByBrandAction,
  NpcByBrandActionTypes,
  NpcByBrandPayload,
} from '../../types/npcByBrand';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getNpcByBrand =
  (data: NpcByBrandPayload) =>
  async (dispatch: Dispatch<NpcByBrandAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcByBrandActionTypes.SET_NPC_BY_BRAND_LOADING,
      });

      const res = await axios.post('/api/npcreports/bybrand', body, config);
      dispatch({
        type: NpcByBrandActionTypes.GET_NPC_BY_BRAND,
        payload: res.data,
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcByBrandActionTypes.GET_NPC_BY_BRAND,
        payload: {
          profitCenters: [],
          markets: [],
          locationIds: [],
          locations: [],
          byMonth: [],
          total: {},
        },
      });
    }
  };

export const getNsBrands =
  () => async (dispatch: Dispatch<NpcByBrandAction | any>) => {
    try {
      const res = await axios.get('/api/npc/brands');
      dispatch({
        type: NpcByBrandActionTypes.GET_ALL_NS_BRANDS,
        payload: res.data,
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcByBrandActionTypes.GET_ALL_NS_BRANDS,
        payload: [],
      });
    }
  };

export const clearNpcByBrand =
  () => async (dispatch: Dispatch<NpcByBrandAction>) => {
    dispatch({
      type: NpcByBrandActionTypes.CLEAR_NPC_BY_BRAND,
    });
  };
